import { fetchSavedVideosApi, pinVideoApi } from 'common/api';
import { put } from 'redux-saga/effects';
import i18next from 'i18next';
import { errorHandleAction } from 'components/error-handle/actions';
import { updateVideoSavedAction } from 'components/video-box/actions';
import { reduxNotificationAction } from 'components/redux-notification/actions';
import { REDUX_NOTIFICATION_TYPES } from 'components/redux-notification';
import { collectionIsLoadingAction, collectionSetInStoreAction } from 'common/actions';
import { savedVideosSuccessAction } from 'pages/saved-videos.page';

export function* pinVideoEffect({ payload }) {
  const { videoId, userId, refreshCollection, pageNumber, perPage, sort } = payload;

  try {
    yield put(updateVideoSavedAction(true));
    yield pinVideoApi(userId, videoId);
    yield put(
      reduxNotificationAction(i18next.t('added_video_to_favourites'), true, 5, REDUX_NOTIFICATION_TYPES.SUCCESS)
    );
    if (refreshCollection) {
      yield put(collectionIsLoadingAction());
      const collection = yield fetchSavedVideosApi(userId, perPage, pageNumber, sort);
      yield put(collectionSetInStoreAction(collection));
      yield put(savedVideosSuccessAction(collection));
    }
  } catch (error) {
    yield put(updateVideoSavedAction(false));
    yield put(errorHandleAction(error, error.status));
    yield put(reduxNotificationAction(i18next.t('server_error'), true, 5, REDUX_NOTIFICATION_TYPES.ERROR));
  }
}
